import ReactGA from "react-ga4";
import config from "../config.json";

const isProdApiUrl = !config.apiUrl.includes("console-staging");
const isProdUrl = window.location.href.includes("app.neoinsurance.co.in");

export const initGA = () => {
  if (!isProdApiUrl && !isProdUrl) return;
  ReactGA.initialize(config.GA_ID);
};

export const logPageView = (path, title) => {
  if (!isProdApiUrl && !isProdUrl) return;
  const payload = { hitType: "pageview", page: path, title };
  ReactGA.send(payload);
};

export const logEvent = (category, action, label = "", value = 0) => {
  if (!isProdApiUrl && !isProdUrl) return;
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};

export const logCustomEvent = (name, params) => {
  if (!isProdApiUrl && !isProdUrl) return;
  ReactGA.event(name, params);
};
